import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "hstack gap-1 h-100" }
const _hoisted_2 = { key: 0 }

import {defineComponent, watch, ref} from "vue";
import type {PropType} from "vue";
import Datepicker from "@vuepic/vue-datepicker";
import {BFilter} from "@/components/BFilterEditor/BFilterEditor.types";

const dateFormat = "yyyy-MM-dd";


export default /*@__PURE__*/_defineComponent({
  __name: 'DateField',
  props: {
    items: {},
    disabled: { type: Boolean },
    modelValue: {},
    label: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

var datePicker = ref<any | null>(null);
const filterValue = ref(props.modelValue ?? "");
const emit = __emit;

function handleUpdate(event:any){            
    emit('update:modelValue', event);
    
    if(datePicker.value != null){
        datePicker.value.focus();
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label != '')
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createVNode(_unref(Datepicker), {
      ref_key: "datePicker",
      ref: datePicker,
      "model-value": _ctx.modelValue,
      format: dateFormat,
      "enable-time-picker": false,
      utc: true,
      clearable: true,
      required: true,
      "input-class-name": 'form-control h-100',
      "auto-apply": "",
      enterSubmit: true,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (handleUpdate($event)))
    }, null, 8, ["model-value"])
  ]))
}
}

})